import * as React from "react";
import {css, cx} from "emotion";

import "./left-nav-item-dropdown-products.scss";

import {ActiveWheel}    from "@Common/react/active-wheel";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {UseState}       from "@Common/react/use-state";
import {chain}          from "@Common/utils/fs";
import {oMapToArr}      from "@Common/utils/objects";

import {Tooltip} from "@Xpresso/common/tool-tip";

import {FlexMenuInternalLink} from "../../../../../common/components/flex-internal-link";

import {rCatScroll} from "./cat-scroll";
import {SubCats}   from "./sub-cats";

export const LnidProducts = ({left, navBlock}) => {
    const padBetweenBarAndCategory = 1.8;
    let categoriesLeftPad = 0;
    let ratio = 1;
    let marginLeft = "0";
    let arrowLeftShift = "5.2rem";
    if(left < 194.828) {
        ratio = 0.7;
        marginLeft =  "auto";
        categoriesLeftPad = 1.875 + 1.875;//headerLeftPad + headerRightPad
        arrowLeftShift = "0rem";
    }
    const categoryLength = `6rem + ${ratio * left}px`;
    const arrowPosition = `calc(${categoryLength} - ${arrowLeftShift})`;
    return cs(
        consumeContext("themeScheme"),
        consumeContext("apis"),
        consumeContext("catSubStyle"),
        consumeContext("editor"),
        ["catSubStyle", ({catSubStyle}, next) => next(catSubStyle?.value)],
        ["focused", (_, next) => UseState({next})],
        ["catScroll", (_, next) => rCatScroll(next, arrowPosition)],
        ({catSubStyle, focused, catScroll, themeScheme, editor}:{catSubStyle, focused, catScroll, themeScheme, editor}) => (
            <div className="lnid-products-9sw">

                <Tooltip/>

                <div
                    className={cx("cats", css`
                    &:after {
                        background: ${themeScheme.xpresso.menuTextColor};
                    }
                    `)}
                    style={{
                        marginRight: `calc(100% - ${categoriesLeftPad}rem - 6rem - ${ratio * left - (editor?.value ? 330 : 0)}px - ${padBetweenBarAndCategory}rem)`,
                        marginLeft: marginLeft,
                        borderRight: `1px solid ${themeScheme.xpresso.menuTextColor}`
                    }}
                >
                    {catSubStyle &&
                    catScroll.render(
                        chain(
                            oMapToArr(catSubStyle, (v, id) => ({...v, id})),
                            (_) => sessionStorage.getItem("listingId") ? _ : _.filter((cat) => !cat.program),
                            (_) => _.sort((a, b) => {
                                if ( a.categoryType != "subscriber" && b.categoryType == "subscriber" ) {
                                    return 1;
                                }
                                else if ( a.categoryType == "subscriber" && b.categoryType != "subscriber" ) {
                                    return -1;
                                }
                                else {
                                    return a.seq - b.seq;
                                }
                            }),
                        ).map((cat) => cs(
                            keyed(cat.id),
                            () => (
                                FlexMenuInternalLink({
                                    className: cx("cat", {focused: focused.value === cat.id},
                                        css`
                                        color: ${themeScheme.xpresso.menuTextColor} !important;

                                        &.focused {
                                            &:after {
                                                border-right-color: ${themeScheme.xpresso.menuTextColor} !important;
                                            }
                                        }
                                    `
                                    ),
                                    style: {
                                        paddingRight: `${padBetweenBarAndCategory}rem`
                                    },
                                    onMouseOver: () => focused.onChange(cat.id),
                                    "data-tip": cat.name,
                                    "xd-qa-type": "link",
                                    "xd-qa-name": cat.name,
                                    navBlock,

                                    ...cat.link && /^\/?cat\/\d+\/sub\/\d+$/.test(cat.link) ? {
                                        to: cat.link,
                                    } : cat.link?.indexOf("/app") > -1 ? {
                                        to: cat?.link.substring(cat?.link.indexOf("/app") + ("/app").length )
                                    } : cat.link ? {
                                        href: cat.link,
                                    } : {
                                        to: cat.child.length === 1 ? `/cat/${cat.id}/sub/${cat.child[0].id}` : `/cat/${cat.id}`,
                                    },
                                    children: cat.name,
                                })
                            ),
                        ))
                    )}
                </div>

                <ActiveWheel
                    className="sub-cats-box"
                    style={{
                        left: `calc(${categoriesLeftPad}rem + 6rem + ${ratio * left - (editor?.value ? 330 : 0)}px  + ${padBetweenBarAndCategory}rem)`
                    }}
                    onWheel={(e) => e.preventDefault()}
                >
                    {focused.value != null && (
                        SubCats({
                            catId: focused.value,
                            subCatList: catSubStyle[focused.value].child.sort( (sub1, sub2)=> (sub1.seq - sub2.seq) ),
                            navBlock,
                        })
                    )}
                </ActiveWheel>
            </div>
        )
    )
};
